import { Log, Result, Telemetry } from 'core/infrastructure';

declare global {
	interface CommandType { }
}

// Usamos este tipo para obligar a que los command handler registrados tengan el tipo adecuado en base a lo que está definido en el interface,
// y que ese tipo siempre sea una función que devuelve un Promise<Result<X>>
type CommandHandler<K extends keyof CommandType> = CommandType[K] extends (...args: any[]) => Promise<Result<any, any>> ? CommandType[K] : 'Cada command debe tener asociada una función que devuelva un Promise<Result<U,V>>';


type Precondition = (() => boolean) | 'NO_PRECONDITION';


type Commands = {
	[Name in keyof CommandType]?: any;
};

const commands: Commands = {};

export function register<CommandName extends keyof CommandType>(commandName: CommandName, precondition: Precondition, action: CommandHandler<CommandName>): void {
	commands[commandName] = async (...args: any[]) => {
		if (precondition !== 'NO_PRECONDITION' && !precondition())
			return Result.error();

		return await (action as any)(...args);
	};
}

export function execute<K extends keyof CommandType>(commandName: K, ...args: Parameters<CommandType[K]>): ReturnType<CommandType[K]> {
	Log.debug(`command["${commandName}"].execute()`);

	Telemetry.command(commandName);

	const command = commands[commandName];
	if (!command)
		throw Error(`No existe ningún comando ${commandName}`);
	return command(...args);
}

